// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__30f3C","buttons":"RemoveExpirationActionButtons_buttons__6GDz8"};